import api from '../../lib/api';
import { User, UserPayload, UserResponse, UserFilters, UserDeletionImpact, DeleteUserApiPayload } from './types';

export const fetchUsers = async (params?: UserFilters): Promise<UserResponse> => {
  const { page = 1, pageSize = 20, sortBy = 'email', sortDir = 'asc', search = '' } = params || {};
  const { data } = await api.get<UserResponse>('users', { params: { page, pageSize, sortBy, sortDir, search } });
  return data;
};

export const createUser = async (payload: UserPayload): Promise<User> => {
  try {
    const { data } = await api.post<{ success: boolean; user: User }>('users', payload);
    return data.user;
  } catch (error: any) {
    // Si es un error del backend, lanzar el mensaje específico
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    // Si no hay mensaje específico, relanzar el error original
    throw error;
  }
};

export const updateUser = async (id: number, payload: UserPayload): Promise<User> => {
  try {
    const { data } = await api.put<{ success: boolean; user: User }>(`users/${id}`, payload);
    return data.user;
  } catch (error: any) {
    // Si es un error del backend, lanzar el mensaje específico
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    // Si no hay mensaje específico, relanzar el error original
    throw error;
  }
};

export const fetchUserDeletionImpact = async (id: number): Promise<UserDeletionImpact> => {
  try {
    const { data } = await api.get<{ success: boolean; impact: UserDeletionImpact }>(
      `users/${id}/deletion-impact`,
    );
    return data.impact;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};

export const deleteUser = async (id: number, payload?: DeleteUserApiPayload): Promise<void> => {
  try {
    await api.delete(`users/${id}`, { data: payload ?? {} });
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};
